import { createAnalytics } from '@/shared/features/analytics/config/analytics.build';
import { generateEventId, getConnectoId } from '@/shared/features/analytics/utils/facebookCommonAttributes';

/**
 * Fires route-level PageView to Meta (pixel + CAPI) and WebEngage.
 * Common client attributes (Page Name, UTM params, etc.) are merged by the WebEngage adapter.
 * Facebook mapping is handled by FacebookAdapter.
 *
 * TEMPORARY: a single `event_id` is generated here and sent to both providers in the
 * same call, so WebEngage's `PageView` event carries the exact same `event_id` used for
 * Meta's PageView (pixel `eventID` + CAPI `event_id`).
 */
export function trackPageView(): void {
  const connectoId = getConnectoId();
  const eventId = generateEventId();
  void createAnalytics()
    .then((analytics) => {
      analytics.trackEvent(
        'PageView',
        {
          ...(connectoId ? { CONNECTO_ID: connectoId } : {}),
          event_id: eventId,
        },
        { eventProviders: ['webengage', 'facebook'] },
      );
    })
    .catch(() => {
      // Analytics may be unavailable if SDK init failed
    });
}
